/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Select,
  Input,
  Form,
  message,
  Tooltip,
} from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import ModalWrapper from './ModalWrapper';
import './settings-modal.scss';

export const taskProviderStatusValue = (status) => {
  if (status === true || status === '1' || status === 'Active') return '1';
  return '0';
};

export const taskProviderIsActive = (status) => taskProviderStatusValue(status) === '1';

export class AddTaskProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editingProviderID: '',
      providerName: props.modalType.data.provider.name,
      providerIsActive: taskProviderStatusValue(props.modalType.data.provider.is_active),
      providerType: props.modalType.data.provider.provider_type,
      providerIsProvider: props.modalType.data.provider.is_provider,
      emrName: props.modalType.data.provider.emr_credential_name,
      emrId: props.modalType.data.provider.emr_credential_id,
      emrNames: props.modalType.data.availableEmrs,
      currentPage: props.modalType.data.currentPage,
      currentSearch: props.modalType.data.currentSearch,
    };
  }

  componentDidMount = async () => {
    const { modalType } = this.props;
    const { provider } = modalType.data;
    if (provider.name) {
      this.setState({
        editingProviderID: provider.id,
      });
    }
  }

  addProvider = async () => {
    const { createTaskProvider, getTaskProviders } = this.props;
    const {
      providerName,
      providerType,
      providerIsProvider,
      emrId,
    } = this.state;
    if (!providerName || providerName.trim() === '') return;
    const newTaskProvider = {
      name: providerName.trim(),
      provider_type: providerType,
      emr_credential_id: emrId,
      is_active: true,
      is_provider: providerIsProvider === 'Yes' || providerIsProvider === true,
    };
    await createTaskProvider(newTaskProvider);
    const { error, hideModal, errorCode } = this.props;
    const errorMessageContent = (errorCode === 400) ? 'Error adding provider. Provider already exists.' : 'Error adding provider. Please try again.';
    if (!error) {
      hideModal();
      message.success({
        content: 'Task Provider successfully added',
      });
    } else {
      hideModal();
      message.error({
        content: errorMessageContent,
      });
    }
    const { currentPage, currentSearch } = this.state;
    const page = currentPage || 1;
    const search = currentSearch || '';
    getTaskProviders(page, search);
  }

  editProvider = async () => {
    const { updateTaskProvider, getTaskProviders } = this.props;
    const {
      editingProviderID,
      providerName,
      providerType,
      providerIsActive,
      providerIsProvider,
      emrId,
    } = this.state;
    let type = '';
    if ((providerType === 'user') || (providerType === 'User')) {
      type = 'user';
    } else {
      type = 'staff_group';
    }
    const newTaskProvider = {
      name: providerName.trim(),
      provider_type: type,
      emr_credential_id: emrId,
      is_active: taskProviderIsActive(providerIsActive),
      is_provider: providerIsProvider === 'Yes' || providerIsProvider === true,
    };
    await updateTaskProvider(editingProviderID, newTaskProvider);
    const { error, hideModal, errorCode } = this.props;
    const errorMessageContent = (errorCode === 400) ? 'Error updating provider. Provider already exists.' : 'Error updating provider. Please try again.';
    hideModal();
    if (!error) {
      message.success({
        content: 'Task Provider successfully updated',
      });
    } else {
      message.error({
        content: errorMessageContent,
      });
    }
    const { currentPage, currentSearch } = this.state;
    const page = currentPage || 1;
    const search = currentSearch || '';
    getTaskProviders(page, search);
  }

  renderModal = () => {
    const { isLoading } = this.props;
    const {
      editingProviderID,
      providerName,
      providerType,
      providerIsActive,
      providerIsProvider,
      emrName,
      emrNames,
    } = this.state;

    const handleTaskProviderType = (e) => {
      this.setState({ providerType: e });
    };

    const handleStatusChange = (e) => {
      this.setState({ providerIsActive: e });
    };

    const handleIsProviderChange = (e) => {
      this.setState({ providerIsProvider: e });
    };

    const handleEmrNameChange = (e) => {
      if (e === '') {
        this.setState({ emrId: null });
      } else {
        const emr = emrNames.find(singleEmr => singleEmr.id === e);
        this.setState({ emrId: emr.id, emrName: emr.name });
      }
    };

    if (isLoading) {
      return (<span> Adding new provider... </span>);
    }
    return (
      <React.Fragment>
        <Form
          layout="vertical"
          onFinish={!editingProviderID && this.addProvider}
          id="addProvider"
        >
          <Form.Item
            hasFeedback
            label={(
              <Tooltip title="Must match the name exactly as it appears in your EMR's Assign To dropdown — case, punctuation, spacing and all. If it doesn't match, tasks created in Medsender won't route to anyone in your EMR.">
                Provider Name
                <InfoCircleOutlined style={{ paddingLeft: '3px', marginTop: '6px', height: '10px' }} />
              </Tooltip>
            )}
            rules={[
              {
                required: true,
                message: 'Must provide a provider name',
              },
            ]}
          >
            <Input
              value={providerName}
              placeholder={providerName}
              onChange={event => this.setState({ providerName: event.target.value })}
            />
          </Form.Item>
          <div style={{ display: 'flex', gap: '10px' }}>
            <Form.Item
              style={{ flex: 0.5 }}
            >
              <Tooltip title="User = an individual staff member in your EMR. Staff Group = a named group that multiple people belong to (e.g. 'Front Desk', 'Billing'). Pick the one that matches how the entry is set up in your EMR.">
                Provider Type
                <InfoCircleOutlined style={{ paddingLeft: '3px', marginTop: '6px', height: '10px' }} />
              </Tooltip>
              <Select
                optionFilterProp="children"
                placeholder="Provider Type"
                onChange={handleTaskProviderType}
                filterOption={false}
                value={providerType}
                options={[
                  {
                    value: 'user',
                    label: 'User',
                  },
                  {
                    value: 'staff_group',
                    label: 'Staff Group',
                  },
                ]}
              >
                {}
              </Select>
            </Form.Item>
            <Form.Item
              style={{ flex: 0.5 }}
            >
              <Tooltip title="Set to Yes only for clinicians who can be the Ordering Provider on a chart (typically MDs, NPs, PAs). Yes entries appear in the Ordering Provider dropdown when sending records to chart. Leave No for front-desk, billing, and other non-clinical staff or groups.">
                Is Provider
                <InfoCircleOutlined style={{ paddingLeft: '3px', marginTop: '6px', height: '10px' }} />
              </Tooltip>
              <Select
                allowClear={false}
                placeholder="Is Provider"
                onChange={handleIsProviderChange}
                value={providerIsProvider === true || providerIsProvider === 'Yes' ? 'Yes' : 'No'}
                options={[
                  { value: 'Yes', label: 'Yes' },
                  { value: 'No', label: 'No' },
                ]}
              />
            </Form.Item>
          </div>
          {
            (emrNames && emrNames.length > 2)
            && (
            <Form.Item
              style={{ flex: 0.5 }}
            >
              <Tooltip title="Which EMR login this entry belongs to. Entries tied to a specific EMR Credential only appear when that credential is in use. Entries set to 'Organization' are shared across all credentials and are the fallback when no credential is attached to the fax line.">
                Emr Credential Name
                <InfoCircleOutlined style={{ paddingLeft: '3px', marginTop: '6px', height: '10px' }} />
              </Tooltip>
              <Select
                optionFilterProp="children"
                placeholder="Emr Credential Name"
                onChange={handleEmrNameChange}
                filterOption={false}
                value={emrName}
              >
                {this.state.emrNames.map(emr => <Select.Option key={emr.id} value={emr.id}>{emr.name}</Select.Option>)}
              </Select>
            </Form.Item>
            )
          }
          {
            (editingProviderID)
            && (
            <div style={{ display: 'flex', gap: '10px' }}>
              <Form.Item
                style={{ flex: 0.5 }}
              >
                <Tooltip title="Only Active entries appear in Send to Chart and Create Task modals. Set to Inactive instead of deleting when someone leaves — keeps history intact and stops them from being assigned new work.">
                  Status
                  <InfoCircleOutlined style={{ paddingLeft: '3px', marginTop: '6px', height: '10px' }} />
                </Tooltip>
                <Select
                  allowClear={false}
                  onChange={handleStatusChange}
                  placeholder="Status"
                  value={providerIsActive}
                  options={[
                    {
                      value: '1',
                      label: 'Active',
                    },
                    {
                      value: '0',
                      label: 'Inactive',
                    },
                  ]}
                />
              </Form.Item>
            </div>
            )
        }
        </Form>
      </React.Fragment>
    );
  }

  render() {
    const { isLoading, hideModal, modalType: { data: { isAdmin } } } = this.props;
    const {
      editingProviderID,
      providerName,
      providerIsActive,
      providerType,
      emrName,
      emrNames,
    } = this.state;
    const customContentStyle = {
      width: '340px',
    };

    return (
      <ModalWrapper
        wrapClassName="settings-modal-wrap"
        hideModal={hideModal}
        customContentStyle={customContentStyle}
        action={!editingProviderID ? this.addProvider : this.editProvider}
        actionName={editingProviderID ? 'Save' : 'Add'}
        dismiss={isLoading ? '' : 'Cancel'}
        disabled={!providerName || !providerType || !isAdmin || (emrNames.length > 2 && !emrName) || (editingProviderID && !providerIsActive)}
        form="addProvider"
        modalTitle={editingProviderID ? 'Edit Task Provider' : 'Add New Task Provider'}
      >
        <div onKeyPress={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        }}
        >
          {this.renderModal()}
        </div>
      </ModalWrapper>
    );
  }
}

AddTaskProvider.defaultProps = {
  error: false,
  errorCode: null,
};

AddTaskProvider.propTypes = {
  hideModal: PropTypes.func.isRequired,
  modalType: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  getTaskProviders: PropTypes.func.isRequired,
  updateTaskProvider: PropTypes.func.isRequired,
  createTaskProvider: PropTypes.func.isRequired,
  error: PropTypes.bool,
  errorCode: PropTypes.string,
};

export default connect(state => ({
  allEmaTaskProviders: state.userProfile.allEmaTaskProviders,
  allDocumentCategories: state.userProfile.allDocumentCategories,
  isLoading: state.userProfile.isLoading,
  error: state.userProfile.error,
  errorCode: state.userProfile.errorCode,
}))(AddTaskProvider);
